export default __webpack_public_path__ + "static/media/622.a1ab33ef.gif";